import { UserInfoViewFragment } from 'generated/graphql';

export const getDashboardAuthor = (author: UserInfoViewFragment) => {
  return [author.firstName, author.lastName].join(' ');
};
